import React, { useContext, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import globalContext from "./globalContext";

function CreateArea(props) {
  const gContext = useContext(globalContext)
  const socket = gContext.socket;

  const [note, setNote] = useState({
    title: "",
    content: ""
  });

  let isTyping = false;
  let timer = null;
  socket.on("typing_status_in", (data) => {
    if (data.typing) {
      console.log("Socket hit recieved", "typing")

      if (!isTyping) {
        gContext.loader.setLoading(true);
        isTyping = true;
      }

      if (timer != null) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        gContext.loader.setLoading(false);
        isTyping = false;
      }, 2000)
    }
  })

  let sentTyping = false;
  function typingHandler() {
    if (!sentTyping) {
      socket.emit("typing_status_out", { typing: true })
      sentTyping = true

      setTimeout(() => {
        sentTyping = false
      }, 2000)
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;

    typingHandler();

    setNote(prevNote => {
      return {
        ...prevNote,
        [name]: value
      };
    });
  }

  function submitNote(event) {
    event.preventDefault();

    if (note.title === "") {
      gContext.snack.setOpen({
        msg: "Please enter title",
        shouldOpen: true
      });
      return
    }
    else if (note.content === "") {
      gContext.snack.setOpen({
        msg: "Please enter content",
        shouldOpen: true
      });
      return
    }

    gContext.notes.addNote(note);
    setNote({
      title: "",
      content: ""
    });
  }

  return (
    <div>
      <form>
        <input
          name="title"
          onChange={handleChange}
          value={note.title}
          placeholder="Title"
        />
        <textarea
          name="content"
          onChange={handleChange}
          value={note.content}
          placeholder="Take a note..."
          rows="3"
        />
        <button onClick={submitNote}><AddIcon /></button>
      </form>
    </div>
  );
}

export default CreateArea;
